<template>
    <div>
        <div class="xieyi-title">用户协议及隐私政策</div>
        <div class="xieyi-content">
            <div class="xieyi-content-title">一、特别提示</div>
            <div>1.1 在此特别提醒您（用户）在注册成为明汇筛查及近视防控平台（包括微信端小程序及H5页面，与之关联的明大夫app及小程序、PC端系统，以上程序的全部或部分端口）（以下简称平台）用户之前，请认真阅读本《平台用户协议及隐私政策》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。您同意并点击确认本协议条款且完成注册程序后，才能成为平台的正式注册用户，并享受平台的各类服务。 您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。 若您不同意本协议，或对本协议中的条款存在任何疑问，请您立即停止平台用户注册程序，并可以选择不使用本网站服务。</div>
            <div>1.2 本协议约定平台与用户之间关于“平台”服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本服务的个人、单位。本协议可由平台随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本APP或微信H5页面中查阅最新版协议条款。在修改协议条款后，如果用户不接受修改后的条款，请立即停止使用平台提供的服务，用户继续使用平台提供的服务将被视为接受修改后的协议。</div>
            <div class="xieyi-content-title">二、账号注册</div>
            <div>2.1 用户在使用本服务前需要注册一个平台账号，可通过APP或微信H5页面绑定手机号码进行注册，或不绑定手机号直接通过微信登录，以微信open ID进行注册。请用户使用尚未与平台账号绑定的手机号码，以及未被平台根据本协议封禁的手机号码注册APP账号。平台可以根据用户需求或产品需要对账号注册和绑定的方式进行变更，而无须事先通知用户。</div>
            <div>2.2 如果注册申请者有被平台封禁的先例或涉嫌虚假注册及滥用他人名义注册，及其他不能得到许可的理由，平台将拒绝其注册申请。</div>
            <div>2.3 鉴于平台账号的绑定注册方式，您同意平台在注册时将允许您的手机号码及手机设备识别码或微信open ID等信息用于注册。</div>
            <div>2.4 在用户注册及使用本服务时，平台需要搜集能识别用户身份的个人信息以便平台可以在必要时联系用户，或为用户提供更好的使用体验。平台搜集的信息包括但不限于用户的姓名、地址；平台同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。</div>
            <div class="xieyi-content-title">三、账户安全</div>
            <div>3.1 用户一旦注册成功，成为平台的用户，将得到一个用户名和密码，并有权利使用自己的用户名及密码随时登陆平台。以微信open id免登录情况下不需要输入用户名及密码。</div>
            <div>3.2 用户对用户名和密码的安全负全部责任，同时对以其用户名进行的所有活动和事件负全责。</div>
            <div>3.3 用户不得以任何形式擅自转让或授权他人使用自己的平台用户名。</div>
            <div>3.4 用户对密码加以妥善保管，切勿将密码告知他人，因密码保管不善而造成的所有损失由用户自行承担。</div>
            <div>3.5 如果用户泄漏了密码，有可能导致不利的法律后果，因此不管任何原因导致用户的密码安全受到威胁，应该立即和平台客服人员取得联系，否则后果自负。</div>
            <div class="xieyi-content-title">四、用户声明与保证</div>
            <div>4.1 用户承诺其为具有完全民事行为能力的民事主体，且具有达成交易履行其义务的能力。</div>
            <div>4.2 用户有义务在注册时提供自己的真实资料，并保证诸如手机号码、姓名、所在地区等内容的有效性及安全性，保证平台工作人员可以通过上述联系方式与用户取得联系。同时，用户也有义务在相关资料实际变更时及时更新有关注册资料。</div>
            <div>4.3 用户通过使用平台的过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等发送、回复和相关链接页面，以及其他使用账号或本服务所产生的内容，不得违反国家相关法律制度，包含但不限于如下原则：</div>
            <div class="xieyi-item"> 1）违反宪法所确定的基本原则的；</div>
            <div class="xieyi-item">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</div>
            <div class="xieyi-item">（3）损害国家荣誉和利益的；</div>
            <div class="xieyi-item">（4）煽动民族仇恨、民族歧视，破坏民族团结的；</div>
            <div class="xieyi-item">（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
            <div class="xieyi-item">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
            <div class="xieyi-item">（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>
            <div class="xieyi-item">（8）侮辱或者诽谤他人，侵害他人合法权益的；</div>
            <div class="xieyi-item">（9）含有法律、行政法规禁止的其他内容的。</div>
            <div>4.4 用户不得利用平台账号或本服务制作、上载、复制、发布、传播下干扰平台正常运营，以及侵犯其他用户或第三方合法权益的内容：</div>
            <div class="xieyi-item">（1）含有任何性或性暗示的；</div>
            <div class="xieyi-item">（2）含有辱骂、恐吓、威胁内容的；</div>
            <div class="xieyi-item">（3）含有骚扰、垃圾广告、恶意信息、诱骗信息的；</div>
            <div class="xieyi-item">（4）涉及他人隐私、个人信息或资料的；</div>
            <div class="xieyi-item">（5）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</div>
            <div class="xieyi-item">（6）含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。</div>
            <div class="xieyi-content-title">五、服务内容</div>
            <div>5.1 平台是大安智慧医疗科技（北京）有限公司开发的手机及电脑终端应用。具体服务内容由平台根据实际情况提供，包括但不限于：</div>
            <div class="xieyi-item">（1）视力及屈光筛查；</div>
            <div class="xieyi-item">（2）屈光筛查；</div>
            <div class="xieyi-item">（3）客户沟通与健康教育；</div>
            <div class="xieyi-item">（4）眼健康档案结果查询；</div>
            <div class="xieyi-item">（5）平台可能提供的其他服务。</div>
            <div>5.2 平台有权随时审核或删除用户发布/传播的涉嫌违法或违反社会主义精神文明，或者被平台认为不妥当的内容（包括但不限于文字、语音、图片、视频、图文等）。</div>
            <div>5.3 所有发给用户的通告及其他消息都可通过平台端口或者用户所提供的联系方式发送。</div>
            <div class="xieyi-content-title">六、服务的终止</div>
            <div>6.1 在下列情况下，平台有权终止向用户提供服务：</div>
            <div class="xieyi-item">6.1.1 在用户违反本服务协议相关规定时，平台有权终止向该用户提供服务；如该用户再一次直接或间接或以他人名义注册为用户的，一经发现，平台有权直接单方面终止向该用户提供服务；</div>
            <div class="xieyi-item">6.1.2 用户不得通过程序或其他任何方式套取不正当利益或作弊，若发现用户有作弊行为，平台将立即终止服务，并有权扣除作弊所获得的非正当利益；</div>
            <div class="xieyi-item">6.1.4 一旦平台发现用户提供的数据或信息中含有虚假内容，平台有权随时终止向该用户提供服务；</div>
            <div class="xieyi-item">6.1.5 本服务条款终止或更新时，用户明示不愿接受新的服务条款；</div>
            <div class="xieyi-item">6.1.6 其它平台认为需终止服务的情况。</div>
            <div>6.2 服务终止后，平台没有义务为用户保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。</div>
            <div>6.3 用户理解并同意，即便在本协议终止及用户的服务被终止后，平台仍有权：</div>
            <div class="xieyi-item">6.3.1 继续保存您的用户信息；</div>
            <div class="xieyi-item">6.3.2 继续向用户主张在其使用平台服务期间因违反法律法规、本协议及平台规则而应承担的责任。</div>
            <div class="xieyi-content-title">七、服务的变更、中断</div>
            <div>7.1 鉴于网络服务的特殊性，用户需同意平台会变更、中断部分或全部的网络服务，并删除（不再保存）用户在使用过程中提交的任何资料，而无需通知用户，也无需对任何用户或任何第三方承担任何责任。</div>
            <div>7.2 平台需要定期或不定期地对提供网络服务的平台进行检测或者更新，如因此类情况而造成网络服务在合理时间内的中断，平台无需为此承担任何责任。</div>
            <div class="xieyi-content-title">八、服务条款修改 </div>
            <div>8.1 平台有权随时修改本服务条款的任何内容，一旦本服务条款的任何内容发生变动，平台将会通过适当方式向用户提示修改内容。</div>
            <div>8.2 如果不同意平台对本服务条款所做的修改，用户有权停止使用网络服务。</div>
            <div>8.3 如果用户继续使用网络服务，则视为用户接受平台对本服务条款所做的修改。</div>
            <div>九、免责与赔偿声明</div>
            <div>9.1 若平台已经明示其服务提供方式发生变更并提醒用户应当注意事项，用户未按要求操作所产生的一切后果由用户自行承担。</div>
            <div>9.2 用户明确同意其使用平台所存在的风险将完全由其自己承担，因其使用平台而产生的一切后果也由其自己承担。</div>
            <div>9.3 用户同意保障和维护平台及其他用户的利益，由于用户在使用平台有违法、不真实、不正当、侵犯第三方合法权益的行为，或用户违反本协议项下的任何条款而给平台及任何其他第三方造成损失，用户同意承担由此造成的损害赔偿责任。</div>
            <div>9.4 平台所收集的部分公开资料来源于互联网，转载的目的在于传递更多信息及用于网络分享，并不代表本站赞同其观点和对其真实性负责，也不构成任何其他建议。本站部分作品是由网友自主投稿和发布、编辑整理上传，对此类作品本站仅提供交流平台，不为其版权负责。如果您发现网站上有侵犯您的知识产权的作品，请与我们取得联系，我们会及时修改或删除。</div>
            <div>9.5 平台所提供的信息，只供参考之用。本网站不保证信息的准确性、有效性、及时性和完整性。本网站及其雇员一概毋须以任何方式就任何信息传递或传送的失误、不准确或错误，对用户或任何其他人士负任何直接或间接责任。在法律允许的范围内，本网站在此声明，不承担用户或任何人士就使用或未能使用本网站所提供的信息或任何链接所引致的任何直接、间接、附带、从属、特殊、惩罚性或惩戒性的损害赔偿。</div>
            <div class="xieyi-content-title">十、隐私声明</div>
            <div>10.1 适用范围：</div>
            <div class="xieyi-item">10.1.1 在用户注册平台账户时，根据要求提供的个人注册信息；</div>
            <div class="xieyi-item">10.1.2 在用户使用平台，或访问其相关网页时，平台自动接收并记录的用户浏览器上的服务器数值，包括但不限于IP地址等数据及用户要求取用的网页记录。</div>
            <div>10.2 信息使用：</div>
            <div class="xieyi-item">10.2.1 平台不会向任何人出售或出借用户的个人信息，除非事先得到用户的许可；</div>
            <div class="xieyi-item">10.2.2 平台亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何用户如从事上述活动，一经发现，平台有权立即终止与该用户的服务协议，查封其账号；</div>
            <div class="xieyi-item">10.2.3 为达到服务用户的目的，平台可能通过使用用户的个人信息，向用户提供服务，包括但不限于向用户发出产品和服务信息，或者与平台合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息。</div>
            <div>10.3 信息披露：</div>
            <div>用户的个人信息将在下述情况下部分或全部被披露：</div>
            <div class="xieyi-item">10.3.1 经用户同意，向第三方披露；</div>
            <div class="xieyi-item">10.3.2 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</div>
            <div class="xieyi-item">10.3.3 如果用户出现违反中国有关法律或者网站政策的情况，需要向第三方披露；</div>
            <div class="xieyi-item">10.3.4 为提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息；</div>4
            <div class="xieyi-item">10.3.5 其它平台根据法律或者网站政策认为合适的披露；</div>
            <div class="xieyi-content-title">十一、其他</div>
            <div>11.1 平台郑重提醒用户注意本协议中免除平台责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。</div>
            <div>11.2 本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和平台之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交平台住所地有管辖权的人民法院管辖。</div>
            <div>11.3 本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。 </div>
            <div>11.4 本协议最终解释权归平台所有，并且保留一切解释和修改的权力。</div>
            <div>11.5 本协议从2021年1月1日起适用。</div>
        </div>
    </div>
</template>
<script>
export default({})
</script>
<style lang="less" scoped>
.xieyi-title {
    font-size: 0.36rem;
    line-height: 0.8rem;
    font-weight: bold;
}
.xieyi-content {
    padding: 0 0.3rem;
    text-align: left;
    line-height: 0.5rem;
    font-size: 0.3rem;
    div {
        padding: 0.1rem 0;
        &.xieyi-item {
            margin-left: 1em;
        }
    }
    .xieyi-content-title {
        margin: 0.2rem 0;
        font-weight: bold;
        font-size: 0.32rem;
    }
}
</style>
